import { Navigate, useLocation } from "react-router";

export default function DashboardBuyPanels() {
  const location = useLocation();
  const target = `${location.pathname.replace(/^\/dashboard/, "")}${location.search}`;

  return <Navigate to={target} replace />;
}
